import store from '@/store'
export function jumpPassport() {//根据语言跳转SSO
    if(store.getters.language=='en'){//如果当前语言是英文
        return process.env.VUE_APP_SSO_URL_EN

    }else if(store.getters.language=='zh'){//如果当前语言是中文
        return process.env.VUE_APP_SSO_URL_ZH
    }
}
export function jumpHome() {//根据语言跳转到主站
    if(store.getters.language=='en'){//如果当前语言是英文
        return process.env.VUE_APP_MAIN_URL_EN

    }else if(store.getters.language=='zh'){//如果当前语言是中文
        return process.env.VUE_APP_MAIN_URL_ZH
    }
}
export function jumpClient() {//根据语言跳转到客户端
    if(store.getters.language=='en'){//如果当前语言是英文
        return process.env.VUE_APP_USER_URL_EN

    }else if(store.getters.language=='zh'){//如果当前语言是中文
        return process.env.VUE_APP_USER_URL_ZH
    }
}